/**
 * utils.js
 * Created by calhosh on 11/6/2019.
 */
import env from './env';
import resources from '../resources/resources';
import * as constants from './uiconstants';
let lang = env.getLanguage();
export let currentResource = resources(lang);
export let labels = currentResource.labels;
export let LocalizedUIConstants = constants;

let updateConstantsWithLocale = (prop) => {
	prop.map((p) => {
		p['localizedlabel'] = currentResource[p.label] || p.label;
		return p;
	});
	return prop;
};

/*set user selected language*/
export const setLanguage = (language) => {
	if (language) {
		currentResource = resources(language);
		labels = currentResource.labels;
	}
	let constantCollections = _.pickBy(LocalizedUIConstants, (c) => _.isArray(c) && _.isObject(c[0]));
	LocalizedUIConstants = _.forEach(constantCollections, updateConstantsWithLocale);
};

/**
 * Return number formatted data
 * @param {Number} userPreferenceNumberFormat - number format.
 * @param {string} freeText - freeText.
 *  @returns {string} return number formatted value
 **/
export const numberFormattedText = (userPreferenceNumberFormat, freeText) => {
	if (freeText !== null && freeText.length > 0) {
		switch (userPreferenceNumberFormat) {
			case 0:
				return freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
			case 1:
				let numberText = String(freeText),
					subText = '',
					appendNumber = '';
				if (numberText.length > 3) {
					subText = numberText.substring(0, numberText.length - 3);
					appendNumber = ',' + numberText.substring(numberText.length - 3, numberText.length);
				} else {
					subText = numberText;
				}
				return subText.toString().replace(/(\d)(?=(\d{2})+(?!\d))/g, '$1,') + appendNumber;
			case 2:
				return freeText !== undefined && freeText !== null
					? freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')
					: '';
			case 3:
				return freeText !== undefined && freeText !== null
					? freeText.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.')
					: '';
		}
	} else {
		return ' ';
	}
};

/**
 * Builds an array of properties in a JsonPatch compliant format.
 * @param {String} path JsonPatch path property.
 * @param {Object} value Value for the property being patched.
 * @param {Array} accumulator List of properties to be sent for the PATCH endpoint.
 * @param {String} operation Operation type for the property. "replace" by default.
 * @returns {Array} Array of properties to be updated in a PATCH API call.
 */
export function buildJsonPatchData(path, value, accumulator = [], operation = 'replace') {
	let jsonPatchData = accumulator;
	if (!jsonPatchData) {
		jsonPatchData = [];
	}

	if (path) {
		const patchDataItem = {
			op: operation,
			path: path,
			value: value
		};

		const pathIndex = jsonPatchData.findIndex((item) => item.path === path);
		if (pathIndex < 0) {
			jsonPatchData.push(patchDataItem);
		} else {
			jsonPatchData[pathIndex] = patchDataItem;
		}

		return jsonPatchData;
	}
}

/**
 * Returns an array representation for a JSON Patch operation to modify the supplied parameters.
 * @param {string} clientRequestTitle - Updated client request title
 * @param {int} clientRequestID - Client Request ID.
 * @returns {array} An array containing the fields to update.
 */
export const buildClientRequestTitlePatchOperations = (clientRequestTitle, clientRequestID) => {
	return [
		{
			op: 'replace',
			path: `/${clientRequestID}/RequestTitle`,
			value: clientRequestTitle
		}
	];
};

/**
 * Returns an array representation for a JSON Patch operation to modify the supplied parameters.
 * @param {string} clientRequestDescription - Updated client request description.
 * @param {int} clientRequestID - Client Request ID.
 * @returns {array} An array containing the fields to update.
 */
export const buildClientRequestDescriptionPatchOperations = (clientRequestDescription, clientRequestID) => {
	return [
		{
			op: 'replace',
			path: `/${clientRequestID}/RequestDescription`,
			value: clientRequestDescription
		}
	];
};

export const tiNormalizer = {
	genericProps: ({
		instructionId: id,
		isCustom,
		instructionName: title,
		instructionDescription: description = '',
		knowledgeInstructionDescription,
		knowledgeModifyDate,
		knowledgeDisplayOrder
	}) => {
		const newProps = {
			id,
			isCustom,
			title,
			description,
			knowledgeInstructionDescription,
			knowledgeModifyDate
		};
		if (!isCustom) newProps.knowledgeDisplayOrder = knowledgeDisplayOrder;
		return newProps;
	},
	dueDate: ({dueDate = ''}) => ({dueDate}),
	documents: ({documents}) => ({
		documents: documents.sort((a, b) => a.documentName.localeCompare(b.documentName)),
		documentCount: documents.length
	}),
	scopes: ({scopes}) => {
		if (scopes && scopes.length !== 0) {
			return {
				scopes: [
					...scopes.filter(({isSubScope}) => !isSubScope).sort((a, b) => a.scopeTypeId - b.scopeTypeId),
					...scopes.filter(({isSubScope}) => isSubScope).sort((a, b) => a.scopeName.localeCompare(b.scopeName))
				],
				scopeCount: scopes.filter((s) => s.actualRecommendationTypeID === constants.gaRecommendationType.required)
					.length
			};
		}
		return {};
	},
	teams: ({components: teams}) => {
		if (teams && teams.length !== 0) {
			return {teams: teams.sort((a, b) => a.componentName.localeCompare(b.componentName)), teamCount: teams.length};
		}
		return {};
	},
	filterSortKnowledge: (list, prop = 'knowledgeDisplayOrder', option = null) => {
		if (option === 'noRF')
			return list
				.filter(
					({isCustom, knowledgeInstructionSectionId}) =>
						!isCustom && knowledgeInstructionSectionId !== constants.knowledgeInstructionsSectionsIds.groupTasks
				)
				.sort((a, b) => a[prop] - b[prop]);
		if (option === 'RF')
			return list
				.filter(
					({isCustom, knowledgeInstructionSectionId}) =>
						!isCustom && knowledgeInstructionSectionId === constants.knowledgeInstructionsSectionsIds.groupTasks
				)
				.sort((a, b) => a[prop] - b[prop]);
		return list.filter(({isCustom}) => !isCustom).sort((a, b) => a[prop] - b[prop]);
	},
	filterSortCustom: (list, prop = 'instructionName') =>
		list.filter(({isCustom}) => isCustom).sort((a, b) => a[prop].localeCompare(b[prop]))
};

/**
 * Normalizes a collection of elements based on redux's docs recommendations.
 * https://redux.js.org/recipes/structuring-reducers/normalizing-state-shape
 * @param {Array} value A collection of elements to be normalized.
 * @param {String} key A string representing the element's id field name.
 * @param {object} initialState An initial state with a normalized form.
 * @param {function} mergeStrategy A strategy to merge already detected entities.
 * @returns {object} An object with the normalized state.
 */
export function normalize(
	value,
	key = 'id',
	initialState = undefined,
	mergeStrategy = lastOneWinsMergeStrategy,
	replace = false
) {
	let result = {
		byId: {},
		allIds: []
	};

	if (initialState) {
		result.byId = replace ? {} : {...initialState.byId};
		result.allIds = replace ? [] : [...initialState.allIds];
	}

	if (!(value === null || value === undefined || (Array.isArray(value) && !value.length > 0))) {
		for (const element of value) {
			if (element !== null) {
				let id = element[key];

				if (!result.byId[id]) {
					result.allIds.push(id);
				}

				mergeStrategy(id, element, result);

				if (key !== 'id') {
					delete result.byId[id][key];
				}
			}
		}
	}

	return result;
}

/**
 * Grabs an entity received from a child and mutates the store accordingly, last one wins.
 * @param {number} id The entity's Id.
 * @param {object} element The response's iterated element.
 * @param {object} result The normalized slice.
 */
export function lastOneWinsMergeStrategy(id, element, result) {
	result.byId[id] = {
		...result.byId[id],
		...element,
		id
	};
}

/**
 * Grabs an entity received from a child and mutates the store accordingly, if last one has a truthy value, this new value replaces the existing one.
 * @param {number} id The entity's Id.
 * @param {object} element The response's iterated element.
 * @param {object} result The normalized slice.
 */
export function truthyWinsMergeStrategy(id, element, result) {
	if (element !== null) {
		result.byId[id] = {
			...result.byId[id]
		};

		Object.entries(element).forEach((entry) => {
			const key = entry[0],
				value = entry[1];

			if (key === 'id') {
				result.byId[id][key] = id;
			} else if (value !== null && value !== undefined) {
				result.byId[id][key] = value;
			} else if (result.byId[id][key] === undefined) {
				result.byId[id][key] = value;
			}
		});
	}
}

export const stringVariableReplacer = (string, value) => {
	const splitted = string.split('<b>');
	return `${splitted[0]}${value}${splitted[2]}`;
};

export const isNullOrWhitespace = (input) => {
	return !input || !input.trim();
};

export const IsIE11 = false || !!document.documentMode;

export function isNullOrUndefined(value) {
	return value === null || value === undefined;
}

/**
 * Check if a function reference is valid.
 * @param {Function} fn function referece to check.
 * @returns {Bool} true if function is valid, false if not.
 */
export function isFunctionValid(fn) {
	return !isNullOrUndefined(fn) && typeof fn === 'function';
}

/**
 * Check if at least one has a new version available to send.
 * @param {object} scope scope entity.
 * @returns {Bool} true if it has.
 */
export function isTeamNewerVersion(scope) {
	return scope?.teamList?.some((team) => {
		if (team?.teamInstructionSentDate === null) {
			return team?.scopeInstructionSentDate !== null && team?.selected;
		}

		return Date.parse(team?.teamInstructionSentDate) < Date.parse(team?.scopeInstructionSentDate) && team?.selected;
	});
}
export function isLinkSendSelected(scope) {
	return scope?.teamList?.some((team) => {
		return team?.selected;
	});
}
export function sortingArray(notes, criterial) {
	let criterialCompare;
	switch (criterial?.sortOrder) {
		case 'priority':
		case 'Priority':
			criterialCompare = 'priorityTypeId';
			break;
		case 'modifiedDate':
			criterialCompare = 'modifiedDate';
			break;
		case 'DueDate':
			criterialCompare = 'dueDate';
			break;
		case 'number':
		case 'Number':
			criterialCompare = 'referenceNumber';
			break;
		case 'Status':
		case 'status':
			criterialCompare = 'statusId';
			break;
		default:
			criterialCompare = 'referenceNumber';
			break;
	}

	function compare(a, b) {
		if (a['categoryDisplayName'] && b['categoryDisplayName']) {
			if (a['categoryDisplayName'].toLowerCase() === b['categoryDisplayName'].toLowerCase()) {
				if (a[criterialCompare] < b[criterialCompare]) {
					return criterial?.isAscending ? -1 : 1;
				}
				if (a[criterialCompare] > b[criterialCompare]) {
					return criterial?.isAscending ? 1 : -1;
				}
				return 0;
			}
			return a['categoryDisplayName'].toLowerCase().localeCompare(b['categoryDisplayName'].toLowerCase()) ? 1 : -1;
		} else {
			if (a[criterialCompare] < b[criterialCompare]) {
				return criterial?.isAscending ? -1 : 1;
			}
			if (a[criterialCompare] > b[criterialCompare]) {
				return criterial?.isAscending ? 1 : -1;
			}
			return 0;
		}
	}
	return notes.sort(compare);
}

export function getFileExtension(fullFileName, includeDot = true) {
	if (!fullFileName) {
		return undefined;
	}
	if (fullFileName.indexOf('.') < 0) {
		return '';
	}

	if (fullFileName.startsWith('.')) {
		return '';
	}

	const split = fullFileName.split('.');
	let fileExt = split.pop();
	fileExt = (includeDot ? '.' : '') + fileExt;

	return fileExt;
}

export function getFileName(fullFileName) {
	if (!fullFileName) {
		return undefined;
	}
	if (fullFileName.indexOf('.') < 0) {
		return fullFileName;
	}

	if (fullFileName.startsWith('.')) {
		return fullFileName;
	}

	// Split and remove last element (extension)
	const split = fullFileName.split('.').slice(0, -1);
	const fileName = split.join('.');

	return fileName;
}

export function containsRestrictedChars(str) {
	const regexName = /^[^*/:<>\\?|"]+$/g;
	return !regexName.test(str);
}

/**
 * Return number formatted data
 * @param {Number} userPreferenceNumberFormat - number format.
 * @param {Number} userNegativeNumberFormat - negative number format.
 * @param {string} freeText - freeText.
 * @param {string} suffix - suffix.
 * @returns {string} return number formatted value
 **/
export const negativeNumberFormattedText = (
	userPreferenceNumberFormat,
	userNegativeNumberFormat,
	freeText,
	suffix = ''
) => {
	let formatedText = numberFormattedText(userPreferenceNumberFormat, freeText);
	if (freeText && freeText >= 0) {
		return formatedText + suffix;
	}

	formatedText = formatedText.replace('-', '');

	switch (userNegativeNumberFormat) {
		case 0:
			return '(' + formatedText + ')' + suffix;
		case 1:
			return '-' + formatedText + suffix;
		case 2:
			return '- ' + formatedText + suffix;
		case 3:
			return formatedText + '-' + suffix;
		case 4:
			return formatedText + ' -' + suffix;
		default:
			return '(' + formatedText + ')' + suffix;
	}
};

/*set thousand separator*/
export const setThousandSeparator = (numberFormat) => {
	let thousandSeparator = '',
		decimalSeparator = '.',
		thousandsGroupStyle = 'thousand';
	switch (
		numberFormat === undefined || numberFormat === '' || numberFormat === 0
			? constants.numberFormats[0].id
			: numberFormat
	) {
		case constants.numberFormats[0].id /*'1,234,567,890'*/:
			thousandSeparator = ',';
			break;
		case constants.numberFormats[1].id /*need to figure this out*/ /*'1,23,45,67,890'*/:
			thousandSeparator = ',';
			thousandsGroupStyle = 'lakh';
			break;
		case constants.numberFormats[2].id /*'1 234 567 890'*/:
			thousandSeparator = ' ';
			break;
		case constants.numberFormats[3].id /*'1.234.567.890'*/:
			thousandSeparator = '.';
			/*Decimal and thousands separator cannot be the same. We dont show decimal, so just change it*/
			decimalSeparator = ',';
			break;
		// case constants.numberFormats[4].value /*"1'234'567'890"*/:
		// 	thousandSeparator = `'`;
		// 	break;
		// case constants.numberFormats[5].value /*need to figure this out*/ /*'12,3456,7890'*/:
		// 	thousandSeparator = ',';
		// 	thousandsGroupStyle = 'wan';
		// 	break;
	}
	return {thousandSeparator, decimalSeparator, thousandsGroupStyle};
};

/**
 * Returns the HTTP response code given by an API call.
 * @param {Object} action Redux API action.
 * @returns HTTP status code from the API response.
 */
export function getApiResponseCode(action) {
	const responseCode = action.responseObj?.status;
	return responseCode;
}

/**
 * Check if an API response is OK.
 * @param {Object} action Redux API action.
 * @returns {Boolean} true if the response is OK, false if not.
 */
export function isApiResponseOk(action) {
	const responseCode = getApiResponseCode(action);
	const successCodes = [
		constants.HttpStatusCodes.Ok,
		constants.HttpStatusCodes.NoContent,
		constants.HttpStatusCodes.Created
	];

	return !isNullOrUndefined(action.response) && successCodes.includes(responseCode);
}

/**
 * Removes an entry from a normalized state slice.
 * @param {object} slice The normalized slice.
 * @param {number} id The entity's Id.
 * @returns {object} The mutated slice.
 */
export function normalizedDelete(slice, id) {
	let result = {
		...slice,
		allIds: slice?.allIds?.filter((value) => value !== id)
	};

	if (result?.byId) {
		result.byId = {
			...result.byId
		};
		delete result.byId[id];
	}

	return result;
}

/**
 * Handler function for executing a callback when a click outside a container is detected. To use this, attach this function to the document's click event (document.addEventListener('click', handleOnClickOutside);).
 * @param {String} elementId Id of the container element in the DOM.
 * @param {Function} onClickOutside Callback function executed when a click outside the container is detected.
 * @param {Event} evt Event object.
 */
export function handleOnClickOutside(elementId, onClickOutside, evt) {
	const elem = document.getElementById(elementId);
	if (elem) {
		const outsideClick = typeof evt.composedPath === 'function' && !evt.composedPath().includes(elem);
		if (outsideClick) {
			onClickOutside(evt);
		}
	}
}

/**
 * Function to calculate rounded percentages for a list of counts, considering 99% and 101% for rounding cases.
 * @param {Array} counts
 * @param {number} totalCount
 * @returns {Array} An array with the rounded percentages in the exact same order as the input counts.
 */
export function calculateRoundedPercentages(counts, totalCount) {
	if (totalCount === 0) {
		return counts.map(() => 0);
	}

	const percentages = counts.map((count) => {
		return count === 0 ? 0 : (count * 100) / totalCount;
	});
	const decimals = percentages.map((percentage) => {
		return percentage - Math.floor(percentage);
	});
	const roundedPercentages = percentages.map((percentage) => {
		return Math.round(percentage);
	});
	const totalRoundedPercentage = roundedPercentages.reduce((sum, value) => {
		return sum + value;
	}, 0);

	if (totalRoundedPercentage > 100) {
		const decimalsGreaterThanZero = decimals.filter((decimal) => decimal > 0);
		const minDecimal = Math.min(...decimalsGreaterThanZero);
		const decimalIndex = decimals.indexOf(minDecimal);
		roundedPercentages[decimalIndex] -= 1;
	}

	if (totalRoundedPercentage < 100) {
		const decimalIndex = decimals.indexOf(Math.max(...decimals));
		roundedPercentages[decimalIndex] += 1;
	}

	return roundedPercentages;
}

export function buildCustomFilterURI(clientRequestCustomFilters) {
	let customFilterURI = '',
		selectedFilters = clientRequestCustomFilters;

	Object.keys(selectedFilters).map((key) => {
		customFilterURI += key + ' eq ';

		if (Array.isArray(selectedFilters[key])) {
			selectedFilters[key].length === 1
				? (customFilterURI += "'" + selectedFilters[key] + "'")
				: ((customFilterURI += "'"),
				  selectedFilters[key].forEach((item) => (customFilterURI += item + '|')),
				  (customFilterURI = customFilterURI.slice(0, -1) + "'"));
		} else {
			customFilterURI += "'" + selectedFilters[key] + "'";
		}
		customFilterURI += ',';
	});

	return customFilterURI.length > 0 ? encodeURI(customFilterURI.slice(0, -1)) : '';
}
